import { EmptyInvoice } from 'src/admin-entity/interface/invoice/empty-invoice.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';

export interface InvoiceInitType {
    pagination: {
        page: number;
        take: number;
        beginDate: string;
        endDate: string;
        distributorName: string;
        productName: string;
    };
    emptyInvoicePage: Page<EmptyInvoice>;
}

export const initialState: InvoiceInitType = {
    pagination: {
        page: 0,
        take: 25,
        beginDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        distributorName: '',
        productName: '',
    },
    emptyInvoicePage: {
        page: {
            count: 0,
        },
        list: [],
    },
};
